module.exports = __webpack_public_path__ + "static/img/tit.c423b85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/tit.png
// module id = S2a4
// module chunks = 19